<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent max-width='70%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-divider(light)
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Información del Proveedor
              v-card-text
                v-row(dense)
                  v-col(cols='6')
                    v-text-field(
                      dense,
                      outlined,
                      :readonly='other',
                      v-model='form.nombre',
                      hint="Requerido",
                      persistent-hint,
                      label='Nombre',
                      id="nombreProveedor",
                      v-uppercase)
                  v-col(cols='6' class='d-flex justify-end')
                    div
                      div(class="d-flex justify-end")
                        div( class="pa-0 mr-2" style="width:70px")
                          v-select(v-model='rifLetra' :items='items2' outlined dense :readonly='other')
                        div( class="pa-0")
                          v-combobox(id="rifProveedor" label='Rif' dense outlined :readonly='other' v-mask="'#########'" v-model='rifNumerico', :items='provv', :search-input.sync='search', hint="Requerido", hide-selected='', persistent-hint='', small-chips='')
                            template(v-slot:selection='data' id='checks')
                              v-chip(v-bind='data.attrs' :input-value='data.selected' close='' @click='data.select' @click:close='remove()')
                                | {{ data.item }}
                            template(v-slot:no-data='')
                              v-list-item
                                v-list-item-content
                                  v-list-item-title
                                    | No se han conseguido resultados "
                                    strong {{ search }}
                                    | ". Presiona
                                    kbd enter
                                    |  para crear uno nuevo
                          //- v-text-field(dense outlined :readonly='read' v-model='rifNumerico' label='Rif' v-mask="'#########'" id="rifProveedor")
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Información de Contacto
              v-card-text
                v-row(dense)
                  v-col(cols='12' xs='12' sm='4' md='2')
                    v-autocomplete(autocomplete="off", v-model='numCodigoPro' :items='itemsNum' outlined dense :readonly='read' )
                  v-col(cols='12' xs='12' sm='8' md='4')
                    v-text-field#tlfCliente(v-model='digitos' v-mask="'#######'" :readonly='read' label='Telefono' outlined dense)
                  v-col(cols='12' sm='12' md='6')
                    v-text-field#correoProveedor(dense outlined :readonly='read' v-model='form.email' label='Correo' hint="ejemplo@ejemplo.com")
                v-row(dense v-if="mostrar")
                  v-col(cols='12' sm='12' md='1' v-if="editedIndex === -1 || read === false " class='d-flex justify-end')
                    v-switch.shrink.mr-2.mt-0(v-model='enabled' hide-details color='primary')
                  v-col(cols='12' sm='12' md='5' class='d-flex justify-end')
                    v-text-field(dense outlined :readonly='read' v-model='form.web' :disabled='!enabled' hint="www.ejemplo.com" label='Direccion web' id="webProveedor")
                v-row(align='center' dense)
                  v-col(cols='12' sm='12' md='12')
                    v-textarea(
                      auto-grow,
                      outlined,
                      :readonly='read',
                      v-model='form.direccion',
                      label='Direccion',
                      id="dirProveedor",
                      v-uppercase)
          v-col(cols='12' v-if='config.usuario.valor')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Usuario
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='6' id='user' v-if='!edicion')
                    v-text-field(dense outlined :readonly='read' v-model='form.usuario' label='Usuario del Proveedor')
                  v-col(cols='12' sm='12' md='6' id='pass' v-if='!edicion')
                    v-text-field.input-group--focused(v-model='form.contrasenna' label='Contraseña', dense='', outlined='', :readonly='read', :append-icon="show3 ? 'visibility' : 'visibility_off'", :type="show3 ? 'text' : 'password'", @click:append='show3 = !show3')
          v-col(cols='12' v-if="config.productosAsociados.valor")
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Productos Asociados
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='12' v-if="editedIndex === -1 || read === false")
                    v-autocomplete(autocomplete="off" dense outlined :menu-props="{closeOnContentClick: true}" multiple='multiple' :readonly='read' v-model='proSelec' :items='productos' label='Seleccione los productos')
                      template(v-slot:prepend-item v-if="validarCrearProducto()")
                        v-list(dense)
                          v-list-item( @click='emp = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab dark x-small color='success')
                                v-icon(dark small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Producto al Proveedor
                    ProductoM(:dialog='emp' :editedIndex='-1' @close='emp = false' @save='listarProductos')
                  v-col(cols='6' sm='6' md='9' v-else class='d-flex justify-center')
                    v-row(dense)
                      v-btn(color='primary' dark @click="overlay = !overlay" align="center") Productos Asociados
                      v-overlay(:value="overlay" absolute)
                        v-toolbar(flat color='primary' dark)
                          v-toolbar-title.justify-center Productos Asociados
                        v-data-table.elevation-1(:headers='headers2' :items='productosmos' :items-per-page="5" light sort-by='nombre')
                        v-btn(color='error' small dark @click="overlay = false")
                          v-icon mdi-close
                          | Salir
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='!read' color='success' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
import ProductoM from './ProductoM'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read', 'edicion', 'other', 'mostrar'],
  name: 'ProveedorM',
  data: () => ({
    config: null,
    enabled: false,
    overlay: false,
    show3: false,
    search: '',
    provv: [],
    emp: false,
    proSelec: [],     // para autocomplete del editar y guardar
    productos: [],
    productosin: [],  // copia de proSelect para enviar la peticion
    productosmos: [], // para el data table del overlay
    rifNumerico: '',
    cont: 0,
    rifLetra: '',
    master: '',
    permisosProducto: {},
    headers2: [
      { text: 'Codigo', align: 'center', value: 'nombre' },
      {
        text: 'Nombre',
        value: 'descripcion',
        align: 'center',
        sortable: false
      }
      /* { text: "Marca", value: "idMarca.nombre", align: "right", sortable: false } */
    ],
    numCodigoPro: '0424',
    digitos: '',
    itemsNum: ['0412', '0414', '0424', '0416', '0426', '0248', '0281', '0282', '0283', '0285', '0292', '0240', '0247', '0278', '0243', '0244', '0246',
      '0273', '0278', '0284', '0285', '0286', '0288', '0289', '0241', '0242', '0243', '0245', '0249', '0258', '0287', '0212', '0259', '0268',
      '0269', '0279', '0235', '0238', '0246', '0247', '0251', '0252', '0253', '0271', '0274', '0275', '0212', '0234', '0239', '0287', '0291',
      '0292', '0295', '0255', '0256', '0257', '0272', '0293', '0294', '0275', '0276', '0277', '0278', '0271', '0272', '0212', '0251', '0253',
      '0254', '0261', '0262', '0263', '0264', '0265', '0266', '0267', '0271', '0275' ],
    form: {
      rif: '',
      nombre: '',
      direccion: '',
      telefono: '',
      web: '',
      email: '',
      usuario: '',
      contrasenna: '',
      Empresa: [],
      master: ''
    },
    allproveedores: [],
    items2: ['V', 'E', 'J', 'P', 'G', 'C'],
    existente: false,
    defaultForm: {
      rif: '',
      nombre: '',
      direccion: '',
      telefono: '',
      web: '',
      email: '',
      usuario: '',
      contrasenna: '',
      Empresa: [],
      master: ''
    }
  }),

  components: {
    ProductoM
  },

  watch: {
    rifNumerico (val) {
      if (val) {
        for (let i = 0; i < this.allproveedores.length; i++) {
          if (val === this.allproveedores[i].rif) {
            let dat = val.split('-')
            this.rifLetra = dat[0]
            this.rifNumerico = dat[1]
            this.form._id = this.allproveedores[i]._id
            this.form.nombre = this.allproveedores[i].nombre
            this.form.direccion = this.allproveedores[i].direccion
            this.form.telefono = this.allproveedores[i].telefono
            this.form.web = this.allproveedores[i].web
            this.form.usuario = this.allproveedores[i].usuario
            this.form.contrasenna = this.allproveedores[i].contrasenna
            this.form.email = this.allproveedores[i].email
            this.form.master = this.allproveedores[i].master
            this.existente = true
            if (document.getElementById('pass')) {
              document.getElementById('pass').hidden = true
            } 
            if (document.getElementById('user')) {
              document.getElementById('user').hidden = true
            } 
            if (document.getElementById('nombreProveedor')) {
              document.getElementById('nombreProveedor').disabled = true
            }
          }
        }
      }
    },
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.form.Empresa.map(data => {
          if (data.idEmpresa === this.$store.state.idempresa.idempresa) {
            data.productos.map(data2 => {
              this.productosmos.push(data2)
              this.proSelec.push({
                text: data2.descripcion,
                value: data2._id
              })
            })
          }
        })
      }
      this.desconcatenarRif(val.rif)
      this.desconcatenarNum(val.telefono)
    },
    proSelec (val) {
      if (!this.read) { this.productosin = [...this.proSelec] }
    }
  },

  created () {
    this.config = this.$store.state.config.proveedores
    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
    } else {
      this.master = this.$store.state.usuario._id
    }
    this.listarProductos()
    this.listarProveedores()
    this.permisosProducto = this.$store.state.empresa[0].permisos.find(
        permiso => permiso.ruta === 'Producto'
      )
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Proveedor'
        : this.read
          ? 'Detalles'
          : 'Modificar Proveedor'
    }
  },

  methods: {

    validarCrearProducto () {
      return this.permisosProducto?.accion?.includes('Crear')
    },

    listarProveedores () {
      Api.get('proveedor/all').then(res => {
        this.allproveedores = res.data
        for (let i = 0; i < res.data.length; i++) {
          // let dat = res.data[i].rif.split('-')
          this.provv.push(res.data[i].rif)
        }
      })
    },

    remove () {
      if (!this.other) {
        this.form = Object.assign({}, this.defaultForm)
        this.proSelec = []
        this.rifNumerico = ''
        this.rifLetra = ''
        this.form.rif = ''
        this.form.telefono = ''
        this.productosin = []
        this.productosmos = []
        this.existente = false
        if (document.getElementById('pass')) {
          document.getElementById('pass').hidden = false
        } 
        if (document.getElementById('user')) {
          document.getElementById('user').hidden = false
        } 
        if (document.getElementById('nombreProveedor')) {
          document.getElementById('nombreProveedor').disabled = false
        }
      }
    },
    concatenarRif () {
      this.form.rif = this.rifLetra + '-' + this.rifNumerico
    },

    desconcatenarRif (rif) {
      this.rifLetra = rif.charAt(0)
      this.rifNumerico = rif.substr(2)
    },

    concatenarNum () {
      this.form.telefono = this.numCodigoPro + '-' + this.digitos
    },
    desconcatenarNum (telf) {
      this.numCodigoPro = telf.substr(0, 4)
      this.digitos = telf.substr(5)
    },

    validarCampos () {
      if (
        this.rifLetra === '' ||
        this.rifNumerico === '' ||
        this.form.nombre === '' ||
        this.numCodigoPro === '' ||
        this.digitos === '' /* ||/* ||
        this.form.direccion === '' ||
        this.form.telefono === '' ||
        this.form.usuario === '' ||
        this.form.contrasenna === '' ||
        this.productosin.length === 0 */
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      } /* else if ( this.rifNumerico.length < 7) {
        this.$swal({
          icon: 'error',
          title: 'Rif invalido!',
          text: 'El rif debe tener entre 7 a 9 caracteres'
        })
        return true
      } */
      return false
    },

    /* validarCorreo () {
      if (this.form.email !== '') {
        const validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!validate.test(this.form.email)) {
          this.$swal({
            icon: 'error',
            title: 'Error!',
            text: 'El correo ingresado no cumple con el debido formato'
          })
          return true
        }
      }
      return false
    },

    validarWeb () {
      if (this.enabled) {
        const validate = /^(www|http:\/\/)(.*\.(com$|net$|org$))/
        if (!validate.test(this.form.web)) {
          this.$swal({
            icon: 'error',
            title: 'Error!',
            text: 'La pagina web ingresada no cumple con el debido formato'
          })
          return true
        }
        return false
      }
    }, 

    validarTelefono () {
      if (this.form.telefono.length !== 15) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text:
            'El campo de telefono debe tener 11 digitos, por favor verifique'
        })
        return true
      } else {
        return false
      }
    },*/

    validarEmpresa () {
      let bool = false
  
      bool = this.form.Empresa?.some(empresa => empresa.edicion)


      if (!bool) {
        let nomb = ''
        for (let i = 0; i < this.$store.state.empresa.length; i++) {
          if (this.$store.state.empresa[i].idEmpresa === this.$store.state.idempresa.idempresa) {
            nomb = this.$store.state.empresa[i].nombre
          }
        }
        this.form.Empresa.push({
          nombre: nomb,
          idEmpresa: this.$store.state.idempresa.idempresa,
          permisos: [
            {
              ruta: 'OrdenxCotizar',
              accion: 'Ver Crear Modificar Eliminar'
            }
          ],
          productos: this.productosin,
          edicion: true
        })         
      }
      
   
    },

    listarProductos () {
      Api.get('producto')
        .then(response => {
          this.producto = response.data
          this.producto.map(data => {
            this.productos.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    close () {
      this.$emit('close')
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
        this.form.Empresa = []
        this.proSelec = []
        this.rifNumerico = ''
        this.rifLetra = ''
        this.form.rif = ''
        this.numCodigoPro = ''
        this.digitos = ''
        this.productosin = []
        this.existente = false
        if (document.getElementById('pass')) {
          document.getElementById('pass').hidden = false
        }
        if (document.getElementById('user')) {
          document.getElementById('user').hidden = false
        }
        document.getElementById('nombreProveedor').disabled = false
        this.productosmos = []
      }, 300)
      // pone el dialog del padre en false    
    },

    save () {
      //if (
        /* !this.validarTelefono() &&
        !this.validarCorreo() &&
        !this.validarWeb() && 
        !this.validarCampos()*/
      //) {
        //this.validarEmpresa()
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        //this.concatenarRif()
        //this.concatenarNum()
        this.form.master = this.master
        if (this.editedIndex > -1) {
          Api.put('/proveedor', this.form)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              // llama al metodo edited del padre y devuelde el form, para agregar el archivo editado al arreglo
              this.$emit('edited', this.form)
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          if (this.existente) {
            let info = {
              _id: this.form._id,
              rif: this.form.rif,
              nombre: this.form.nombre,
              direccion: this.form.direccion,
              telefono: this.form.telefono,
              web: this.form.web,
              email: this.form.email,
              Empresa: this.form.Empresa[0]
            }
            Api.put('/proveedor/existente', info)
              .then(response => {
                if (response.data.message) {
                  this.$swal({
                    icon: 'error',
                    title: 'Error al registrar',
                    text: response.data.message
                  })
                } else {
                  this.$swal({
                    icon: 'success',
                    title: 'Proveedor agregado exitosamente',
                    text: 'Todos los cambios han sido efectuados'
                  })
                  // llama al metodo edited del padre y devuelde el form, para agregar el archivo editado al arreglo
                  this.$emit('edited', this.form)
                  this.close()
                }
              })
              .catch(error => {
                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: 'Error al modificar',
                    text: 'Por favor, verifique los datos e intente de nuevo'
                  })
                } else if (error.request) {
                  this.$swal({
                    icon: 'error',
                    title: 'Error de red',
                    text: 'Por favor verique su conexion de internet'
                  })
                } else {
                  console.log('Error', error.message)
                }
              })
          } else {
            Api.post('proveedor', this.form)
              .then(res => {
                if (res.data.message) {
                  this.$swal({
                    icon: 'error',
                    title: 'Error al guardar',
                    text: res.data.message
                  })
                } else {
                  this.$emit('save', this.form)
                  this.$swal({
                    icon: 'success',
                    title: 'Inclusion exitosa',
                    text: 'Todos los datos han sido guardados'
                  })
                  this.close()
                }
              })
              .catch(error => {
                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: 'Error al guardar',
                    text: 'Por favor, verifique los datos e intente de nuevo'
                  })
                } else if (error.request) {
                  this.$swal({
                    icon: 'error',
                    title: 'Error de red',
                    text: 'Por favor verique su conexion de internet'
                  })
                } else {
                  console.log('Error', error.message)
                }
              })
          }
        }
      //}
    }
  }
}
</script>
<style lang='scss'>

.v-chip.v-size--default {
  height: 24px !important;
}
</style>
